"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.PaymentStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentStatuses = ['DRAFT', 'PENDING', 'AUTHORIZING', 'PROCESSING', 'FAILED', 'COMPLETED'];
/**
 * Generic lifecycle status of a payment or refund's money movement — shared between the two rather
 * than each inventing its own vocabulary.
 */
exports.PaymentStatus = typebox_1.Type.Union(exports.PaymentStatuses.map((status) => typebox_1.Type.Literal(status)));
//# sourceMappingURL=payment-status.js.map